import { customersSlice } from "./customersSlice";
import * as defaultActions from "../../../../../redux/_common";

import { get } from "../../../../../api/requester";
import { getErrorMessage, getResponseErrorMessage } from "../../../../../redux/_helpers";
import { cloneDeep } from "lodash";
import { constructInitialFilters } from "../../../../components/common/filters/utils";
import { Dispatch } from "redux";
import { ICustomer, ICustomerEquipment } from "./_interfaces";
import { IQueryParams } from "../../../../common/interfaces/API";
import { filterEmptyParams, refineCustomerForUpdate, refineDataForEdit, refineLightCustomerDataCreation, refineStandartCustomerDataCreation, setNullValueIfNeeded } from "./utils";

const { actions } = customersSlice;
const moduleUrl = '/api/appmasterdata/customers';

export const setValidationErrors = actions.setValidationErrors;


export const getItems = (params:IQueryParams) => defaultActions.getItems(`${moduleUrl}/generalData`, actions, filterEmptyParams(params));

export const getCustomerCreditData = (params:IQueryParams) => async (dispatch:Dispatch) => {
  try {
    dispatch(actions.setCreditDataTabLoading(true));
    const res = await get(`${moduleUrl}/creditData`, filterEmptyParams(params));
    dispatch(actions.setCreditDataTab(res));
    dispatch(actions.clearErrors());
  } catch (errors) {
    dispatch(actions.catchError({
      errors: getErrorMessage(errors, "Oops.. something went wrong!"),//constructErrors(errors),
      callType: "actionsLoading", errorProp: "error"
    }));
  } finally {
    dispatch(actions.setCreditDataTabLoading(false));
  }
}

export const getCustomerClassificationData = (params:IQueryParams) => async (dispatch:Dispatch) => {
  try {
    dispatch(actions.setClassificationDataTabLoading(true));
    const res = await get(`${moduleUrl}/classificationData`, filterEmptyParams(params));
    dispatch(actions.setClassificationDataTab(res));
    dispatch(actions.clearErrors());
  } catch (errors) {
    dispatch(actions.catchError({
      errors: getErrorMessage(errors, "Oops.. something went wrong!"),//constructErrors(errors),
      callType: "actionsLoading", errorProp: "error"
    }));
  } finally {
    dispatch(actions.setClassificationDataTabLoading(false));
  }
}

export const getCustomerBlockData = (params:IQueryParams) => async (dispatch:Dispatch) => {
  try {
    dispatch(actions.setBlockDataTabLoading(true));
    const res = await get(`${moduleUrl}/blockData`, filterEmptyParams(params));
    dispatch(actions.setBlockDataTab(res));
    dispatch(actions.clearErrors());
  } catch (errors) {
    dispatch(actions.catchError({
      errors: getErrorMessage(errors, "Oops.. something went wrong!"),//constructErrors(errors),
      callType: "actionsLoading", errorProp: "error"
    }));
  } finally {
    dispatch(actions.setBlockDataTabLoading(false));
  }
}

export const getCustomerWholesalersData = (params:IQueryParams) => async (dispatch:Dispatch) => {
  try {
    dispatch(actions.setWholesalersTabLoading(true));
    const res = await get(`${moduleUrl}/wholesalers`, filterEmptyParams(params));
    dispatch(actions.setWholesalersTab(res));
    dispatch(actions.clearErrors());
  } catch (errors) {
    dispatch(actions.catchError({
      errors: getErrorMessage(errors, "Oops.. something went wrong!"),//constructErrors(errors),
      callType: "actionsLoading", errorProp: "error"
    }));
  } finally {
    dispatch(actions.setWholesalersTabLoading(false));
  }
}

export const getAdvancedFilterData = (params:IQueryParams) => async (dispatch:Dispatch) => {
  try {
    dispatch(actions.setAdvancedFilterLoading(true));
    const res = await get(`${moduleUrl}/advancedFilter`, filterEmptyParams(params));
    dispatch(actions.setAdvancedFilterTab(res))
  } catch (errors) {
    dispatch(actions.catchError({
      errors: getErrorMessage(errors, "Oops.. something went wrong!"),//constructErrors(errors),
      callType: "actionsLoading", errorProp: "error"
    }));
  } finally {
    dispatch(actions.setAdvancedFilterLoading(false));
  }
}

export const getWholesalersForCustomerSelection = (params:IQueryParams) => async (dispatch:Dispatch) => {
  try {
    dispatch(actions.setWholesalersTabLoading(true));
    const res = await get(`${moduleUrl}/wholesalers`, filterEmptyParams(params));
    dispatch(actions.setWholesalersTab(res))
  } catch (errors) {
    dispatch(actions.catchError({
      errors: getErrorMessage(errors, "Oops.. something went wrong!"),//constructErrors(errors),
      callType: "actionsLoading", errorProp: "error"
    }));
  } finally {
    dispatch(actions.setWholesalersTabLoading(false));
  }
}

export const getDropDownItems = (params: {}) => defaultActions.getDropDownItems(`${moduleUrl}/select`, actions, params);

export const getItemForEdit = (id: string) => defaultActions.getItem(`${moduleUrl}/${id}`, actions, refineDataForEdit);

export const deleteItem = (id: string) => defaultActions.deleteItem(`${moduleUrl}/${id}`, actions);

export const saveItem = (item: {}, id: string | null) =>
  defaultActions.saveItem(
      moduleUrl,
      actions,
      item,
      id,
      id
        ? refineCustomerForUpdate
        : refineStandartCustomerDataCreation,
      'multipart/form-data'
  );


export const saveItemLight = (item: {}, id: string | null) =>
  defaultActions.saveItem(
      `${moduleUrl}/light`,
      actions,
      item,
      id,
      refineLightCustomerDataCreation
  );

/**
 * !!!!!!!!!!!!!!!!!!!!!!!!!!
 */
export const getTableItems = (
  params:IQueryParams,
  data:{
    id: string;
    addedTableItems:ICustomerEquipment[];
    removedTableItems:{id: string}[];
    newItemValues: ICustomer;
  }
) => async (dispatch:Dispatch) => {
  dispatch(actions.startArticlesCall());

  try {
    const res:{items:ICustomerEquipment[], totalCount:number} = await get(`${moduleUrl}/customerEquipments/${data.id}`, params);
    let items = res.items ? res.items : []; // Items Array
    const itemsCount = res.totalCount ? res.totalCount : 0; // Items Count

    // Аdd archived items for adding
    if (data.addedTableItems.length) {
      const archivedArticles:ICustomerEquipment[] = [];
      items.forEach(item => {
        data.addedTableItems.forEach(article => {
          if (item.id === article.id) {
            item.action = "created";
          } else {
            archivedArticles.push(article);
          }
        });
      });

      if (items.length === 0) {
        items = [...new Set([...data.addedTableItems])];
      } else {
        items = [...new Set([...items, ...archivedArticles])];
      }
    }

    // Remove archived items for deletion
    if (data.removedTableItems.length) {
      items.forEach(item => {
        data.removedTableItems.forEach(article => {
          if (item.id === article.id) {
            item.action = "deleted";
          }
        });
      });
    }

    dispatch(actions.setAssortmentArticles({ items, itemsCount, data }));
  } catch (error) {
    const errors = getErrorMessage(error, "Oops.. something went wrong!");
    dispatch(actions.catchError({ errors, callType: "equipmentLoading", errorProp: "equipmentError" }));
  }
};

// Reset equipment table items
export const resetCustomerEquipment = () => async (dispatch:Dispatch) => {
  dispatch(actions.resetCustomerEquipment());
};

/**
 * !!!!!!!!!!!!!!!!!!!!!!!!!!
 */
export const deleteTableItem = (
  id:string,
  data:{
    items: any[];
    newItemValues:ICustomer;
    addedTableItems:ICustomerEquipment[];
    removedTableItems:ICustomerEquipment[];
  }
) => (dispatch:Dispatch) => {
  const deletedArticleIds = cloneDeep(data.removedTableItems);
  let {addedTableItems, newItemValues} = data;
  let newArticles = cloneDeep(data.items);

  const deleteMethod = (a:{id: string, children?: any[], action:string}) => {
    if (a.children)
      a.children = a.children.map(deleteMethod)
    if (a.id === id) {
      a.action = "deleted";
      const isNew = Boolean(addedTableItems.find(item => item.id === a.id));
      if (isNew) {
        addedTableItems = addedTableItems.filter(item => item.id !== a.id);
      } else {
        deletedArticleIds.push(a as ICustomerEquipment);
      }
      return a;
    }
    return a;
  }

  newArticles = newArticles.map(deleteMethod);

  dispatch(actions.deleteAssortmentArticles({ newArticles, deletedArticleIds, addedArticles: addedTableItems, newItemValues }));
  return deletedArticleIds;
};

/**
 * !!!!!!!!!!!!!!!!!!!!!!!!!!
 */
export const addTableItem = (newArticles:ICustomerEquipment[], newArticleIds:ICustomerEquipment[], newItemValues:ICustomer) => (dispatch:Dispatch) => {
  dispatch(actions.addAssortmentArticles({ newArticles, newArticleIds, newItemValues }));
};

/**
 * !!!!!!!!!!!!!!!!!!!!!!!!!!
 */
// Items from search
export const getSearchedItems = (params:{filter:string, assortmentId:string}) => async (dispatch:Dispatch) => {
  try {
    const res = await get(`${moduleUrl}/customerEquipmentsExcept`, {
      Filter: params.filter,
      CustomerId: params.assortmentId ? params.assortmentId : "00000000-0000-0000-0000-000000000000",
    });
    dispatch(actions.setSearchArticles(res));
  } catch (errors) {
    const message = getResponseErrorMessage(errors, "Error occurred!");
    // dispatch(actions.setError({ status: errors?.status, message }));
  }
};
// Reset searched items
export const resetSearchedItems = () => async (dispatch:Dispatch) => {
  dispatch(actions.resetSearchedItems());
};


// -----------------------------------
export const getSearchedClients = (params:{Filter: string}) => async (dispatch:Dispatch) => {
  try {
    dispatch(actions.setSearchCustomersLoading(true));
    const res = await get(`${moduleUrl}/customerSearchList`, params);
    dispatch(actions.setSearchCustomers(res));
    dispatch(actions.setSearchCustomersLoading(false));
  } catch (errors) {
    dispatch(actions.setSearchCustomersLoading(false));
    const message = getResponseErrorMessage(errors, "Error occurred!");
    // dispatch(actions.setError({ status: errors?.status, message }));
  }
};



// ----------------------------------------

export const getFilters = () => async (dispatch:Dispatch) => {
  try {
    const distribution = await get("/api/appmasterdata/customer/distributionTypes/complexSearch");
    const segments = await get("/api/appmasterdata/customer/segments/complexSearch");
    const types = await get("/api/appmasterdata/customer/types/complexSearch");
    const divisions = await get("/api/appmasterdata/customer/divisions/complexSearch");

    dispatch(
      actions.setFilter(
        constructInitialFilters([
          ...(distribution || []),
          ...(segments || []),
          ...(types || []),
          ...(divisions || []),
        ])
      )
    );
    
    return true
  } catch (errors:any) {
    dispatch(actions.catchError({
      errors: getErrorMessage(errors, "Oops.. something went wrong!"),//constructErrors(errors),
      callType: "actionsLoading", errorProp: "error"
    }));
  }
}

export const setFilter = (filters:any[]) => defaultActions.setFilters(filters, actions);


export const clear = () => defaultActions.clearAll(actions);
export const clearCustomer = () => defaultActions.clearItem(actions);
export const clearErrors = () => defaultActions.clearErrors(actions);
